import {
  FiFilePlus,
  FiLayers,
  FiMessageSquare,
  FiRefreshCw,
  FiBarChart2,
} from "react-icons/fi";

import "./Menu.css";
import { useContext } from "react";
import { UserContext } from "../userContext";
import { useTranslation } from "react-i18next";

export default function TeamsMenu() {
  const user = useContext(UserContext);
  const { t, i18n } = useTranslation("common");

  const previewUsers = ["rkern@fh-salzburg.ac.at", "fhs32147@fh-salzburg.ac.at", "e_mfreudenth@fh-salzburg.ac.at"];

  if (!user) return <></>;

  return (
    <div className="position-sticky pt-3">
      <ul className="nav flex-column">
        <li className="nav-item">
          <a href="/teams" className="nav-link">
            <FiMessageSquare />
            {t("teamsMenu.requestTeam")}
          </a>
        </li>
        {(previewUsers.includes(user.username) || user.role.search("office") !== -1) && (
            <li className="nav-item">
              <a href="/teams-jg" className="nav-link">
                <FiMessageSquare /> {"JG-Teams anlegen"}
              </a>
            </li>
        )}
        {user.teamsRole.search("admin") !== -1 && (
          <>
            <h6 className="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
              <span>{t("menu.adminHeadline")}</span>
            </h6>
            <li className="nav-item">
              <a href="/teams-admin" className="nav-link">
                <FiLayers /> {"Teams Admin"}
              </a>
            </li>
            <li className="nav-item">
              <a href="/teams-sync-status" className="nav-link">
                <FiRefreshCw /> {"Teams Sync Status"}
              </a>
            </li>
          </>
        )}
        {previewUsers.includes(user.username) && (
          <>
            <li className="nav-item">
              <a href="/teams-manual" className="nav-link">
                <FiLayers /> {"Manuelle Teams anlegen"}
              </a>
            </li>
          </>
        )}
      </ul>
    </div>
  );
}
